import {Component, Input} from '@angular/core';

// Подсказка в строке партнёра: остаток есть ещё на других его складах.
// Клик раскрывает строки этих складов (sup.whExpanded → tr[appPartnerWhRow] в шаблоне таблицы).
@Component({
  selector: 'app-partner-wh-hint',
  template: `
    <button type="button" class="partner-wh-hint" *ngIf="sup?.others?.length"
            [class.open]="sup.whExpanded" (click)="toggle($event)">
      <span class="arrow"></span>
      ще {{ sup.othersCountText }} шт. на {{ sup.others.length }} {{ sup.others.length == 1 ? 'складі' : 'складах' }}, найшвидше {{ sup.othersEarliest }}
    </button>
  `,
  // Мини-кнопка в стиле .button сайта (styles.scss): тот же оранжевый, тень, шрифт
  styles: [`
    .partner-wh-hint {
      display: inline-block;
      margin-top: 4px;
      padding: 3px 7px 3px 6px;
      border: 0;
      border-radius: 3px;
      background-color: #FF8D33;
      box-shadow: 0 1px 0 #C66D28;
      color: #fff;
      font-family: 'Exo2SemiBold', sans-serif;
      font-size: 11px;
      line-height: 13px;
      text-align: left;
      white-space: normal;
      cursor: pointer;
      user-select: none;
    }

    .partner-wh-hint:hover {
      background-color: #f07f26;
    }

    .partner-wh-hint.open {
      background-color: #d96f1c;
      box-shadow: none;
      transform: translateY(1px);
    }

    .arrow {
      display: inline-block;
      width: 6px;
      height: 6px;
      margin: 0 5px 2px 1px;
      border-right: 2px solid #fff;
      border-bottom: 2px solid #fff;
      transform: rotate(45deg);
      vertical-align: middle;
    }

    .partner-wh-hint.open .arrow {
      transform: rotate(-135deg);
      margin-bottom: -2px;
    }
  `]
})
export class PartnerWhHintComponent {
  @Input() sup: any;

  toggle(event: Event) {
    event.stopPropagation();
    this.sup.whExpanded = !this.sup.whExpanded;
  }
}
